import { useHasBusinessCapability } from '../../shell/session/hooks/useEffectiveBusinessCapabilities';

/** True when catalog/POS should expose variant pickers (clothing, beauty, etc.). */
export function useProductVariantsEnabled(): boolean {
  return useHasBusinessCapability('product_variants');
}
